import React, { useState, useRef, useContext } from "react"
import { Lead, } from "./model"
import { LoadingButton } from "../components/SavingButton";
import { sleep } from "../utils";
import { appendLead, loadCourses } from "./api";
import { useNumberMask } from "../components/number-mask";
import { save, TraitContext } from "./store";

function fakeNumberCheck(phone:string){
    phone = phone.replace(/[^\d]+/g, '');
    return /(\d)\1{4,}/.test(phone);
}

export function LeadForm() {
    const {state, dispatch} = useContext(TraitContext);
    const [lead, setLead] = useState({ name: '', phone: '', email: ''} as Lead);
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false);
    const ref = useRef<HTMLInputElement>();
    useNumberMask({ref, mask: "phone"})

    async function send() {
        if(loading) return;
        setError(null)
        setLoading(true)

        try {
            loadCourses();
            if (!lead.name) {
                throw 'Preencha o nome completo.'
            }
            const phoneRegex = /^\(\d{2}\) \d{4,5}-\d{4}$/;
             if (!phoneRegex.test(lead.phone) || fakeNumberCheck(lead.phone)) {
                 throw 'Preencha um telefone válido.';
            }
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(lead.email)) {
                throw 'Preencha com um e-mail válido.';
            }

            const req = {...lead, traitResult: state.traitResult}
            const courses = await appendLead(req);

            save({lead, traitResult: state.traitResult});

            dispatch({type: "setLead", lead})
            dispatch({type: "setCourses", courses})
        } catch (e) {
            setError(e)
        }

        console.log(lead)
        setLoading(false);
    }

    return (<div className="traits-form">
        <h2>Parabéns!</h2>
        <h4>Só falta mais esta etapa</h4>
        <p className="text-center mb-5">Para que possamos enviar seu resultado por e-mail, por favor, preencha este formulário.</p>
        <div className="form-card">
            
            <div className="form-item">
                <label>Nome:</label>
                <input type="text" className="input" value={lead.name} onChange={e => setLead({ ...lead, name: e.target.value })} />
            </div>

            <div className="form-item">
                <label>Telefone:</label>
                <input ref={ref} type="text" placeholder="(99) 99999-9999" className="input" value={lead.phone} onChange={e => setLead({ ...lead, phone: e.target.value })} />
            </div>

            <div className="form-item">
                <label>E-mail</label>
                <input type="email" className="input" value={lead.email} onChange={e => setLead({ ...lead, email: e.target.value })} />
            </div>
            
            {
                error && <div className="text-danger"><b>Erro:</b> {error}</div>
            }

            <LoadingButton saving={loading} icon="fa fa-envelope" className={`btn btn-primary`} onClick={send}>Enviar</LoadingButton>
        </div>
    </div>);
}

export default LeadForm;